<template>
	<!-- Balance and main content -->
	<div class="w-full md:w-3/4 lg:w-4/5 h-full flex flex-col items-start pair-bg overflow-y-auto custom-scrollbar md:rounded-tr-2xl md:rounded-bl-none md:rounded-tl-none rounded-b-2xl z-10">
		<div class="flex items-center justify-between w-full px-4 md:mt-0 mt-2 md:pt-12 md:px-8">
			<div class="flex items-center justify-center ml-4 md:ml-0">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkExport : lightExport" alt="Wallet Icon" class="w-6 h-6 md:w-8 md:h-8 mr-3"/>
				<h1 class="text-2xl md:text-4xl font-archivomedium text-[var(--text-color)]">
					Export Zpub
				</h1>
				<img src="../assets/BTCicon.png" alt="BTC Icon" class="w-8 h-8 md:w-10 md:h-10 mb-4 ml-2 mt-4 cursor-pointer md:top-16 md:right-16">
				<button @click="$emit('backToOverview')" class="hidden md:block absolute top-8 right-8">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close Icon" class="w-3 h-3"/>
				</button>
			</div>
			<!-- back button -->
			<button @click="$emit('backToOverview')" class="block md:hidden ml-auto md:mt-2 mr-4 flex items-center space-x-1 px-3 py-2 text-sm font-archivoregular text-[var(--secondary-text-color)] bg-[var(--accent-color-50)] hover:bg-[var(--accent-color-30)] rounded-full transition-colors">
				<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
				</svg>
				<span class="hover:text-[var(--secondary-text-color)] text-xs">Back</span>
			</button>
		</div>

		<div class="my-2 mx-auto w-full md:w-[80%] lg:w-[65%] xl:w-[50%] p-4">
		<!-- zPub display with copy icon -->
		<div class="flex flex-col items-center mb-2">
			<h1 class="mb-4 text-center font-archivomedium text-[var(--text-color)]">
				Copy & Export:
			</h1>
			<div class="flex items-center">
				<p class="px-2 text-center text-[var(--secondary-text-color)] font-archivolight text-sm break-all">
					{{ zpub }}
				</p>
				<img @click="$emit('copyZpub')" :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkCopy : lightCopy" alt="Copy Icon" class="w-5 h-5 ml-2 cursor-pointer"/>
			</div>
		</div>
		<!-- Copy & Back Buttons -->
		<div class="flex space-x-4">
			<button @click="$emit('copyZpub')" class="mt-4 w-1/2 font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
				Copy
			</button>
			<button @click="$emit('backToOverview')" class="mt-4 w-1/2 font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
				Back
			</button>
		</div>
		<hr class="w-full border-[var(--border-color)] mt-8 mb-4">
			<h1 class="font-archivoregular text-md text-[var(--text-color)] my-4 text-center">
				Explainer:
			</h1>
			<p class="mb-4 text-center font-archivolight text-sm md:text-md text-[var(--secondary-text-color)]">
				Copying and exporting your zPub into a BTC based watch-only wallet (eg. Sparrow) allows you to interact with this watch-only wallet while signing the transaction on an offline Cardware device.
			</p>
		</div>
	</div>

</template>

<script setup>
	import lightCopy from '../assets/LightCopyIcon.png';
	import darkCopy from '../assets/DarkCopyIcon.png';
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';
	import lightExport from '../assets/ExportLightTheme.png';
	import darkExport from '../assets/ExportDarkTheme.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		zpub: { type: String, required: true }
	});

	const emit = defineEmits([
		'copyZpub', 
		'backToOverview'
	]);
</script>

<style scoped>
/* Uses the global CSS variables and your existing scrollbar & background styles—no extra rules needed */
</style>